import { ArticlesList } from "~/screens/ArticlesListPage"

export default ArticlesList
